import { render } from "./AccountingSystemPeriod.vue?vue&type=template&id=8675a93e&scoped=true"
import script from "./AccountingSystemPeriod.vue?vue&type=script&lang=js"
export * from "./AccountingSystemPeriod.vue?vue&type=script&lang=js"

import "./AccountingSystemPeriod.vue?vue&type=style&index=0&id=8675a93e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8675a93e"]])

export default __exports__